export const DEVELOPER_ACCESS = "DEVELOPER_ACCESS";
export const getDeveloperAccess = (data) => {
    return {
        type: DEVELOPER_ACCESS,
        payload: data
    }
}